module.exports = "<div class=\"ui-g-6\">\n    <fxs-list [(fxsList)]=\"_fxs\" [title]=\"'Todas las funciones'\" [actionIcon]=\"'add'\"\n              (onFxSelected)=\"addFx($event)\"></fxs-list>\n</div>\n\n<div class=\"ui-g-6\">\n    <fxs-list [(fxsList)]=\"_fxsSelected\" [title]=\"'Funciones asignadas'\" [actionIcon]=\"'clear'\"\n              (onFxSelected)=\"removeFx($event)\" [globalFilter]=\"false\"></fxs-list>\n</div>\n<div style=\"clear: both\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/fxs/fxs-picker/fxs-picker.component.html
// module id = ./src/app/admin/fxs/fxs-picker/fxs-picker.component.html
// module chunks = main